import * as React from "react"
import {Box} from "@mui/material"

import EditButton from "./EditButton"
import SkipButton from "./SkipButton"

const stylesBox = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 1
}


export default function actionsColumn(isSkuMappingTable = false) {
	return {
		name: 'actions', label: 'Actions',
		options: {
			filter: false,
			customBodyRowRender: (value, rowData) => {
				return <>
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
						<EditButton rowData={rowData} />
						<SkipButton rowData={rowData} />
					</Box>
					{/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2}}>
						<CreateSkuButton rowData={rowData} />
					</Box> */}
				</>
			}
		}
	}
}